import { apiRequest } from "./apiRequest";
import { errorHandler } from "./errorHandler";

export interface Competitor {
  id: number;
  name: string;
}

export const getCompetitors = async (): Promise<Competitor[]> => {
  try {
    const response = await apiRequest<{ data: Competitor[] }>(
      "get",
      "/websites/competitors"
    );
    return response.data;
  } catch (error) {
    errorHandler(error);
    throw new Error("Failed to fetch competitors");
  }
};
